define([
    "jquery",
    "underscore",
    "backbone",
    "models/quote_model"
], function($, _, Backbone, Quote) {
    return Backbone.View.extend({
        el: '#content_layout',

        events:{
            'click .account_type': function(e){
                if(e) e.preventDefault();

                var type = $(e.currentTarget).data('type');
                if(type){
                    this.accountType =  type;
					//	ECN does not have commodity / index
					if ( type == 'ecn') {
						$("a[data-type='commodity']").hide();
						$("a[data-type='index']").hide();
					} else { 
						$("a[data-type='commodity']").show();
						$("a[data-type='index']").show();
					}
                }
            },
            'click .quote_type': function(e){
                if(e) e.preventDefault();

                var type = $(e.currentTarget).data('type');
                if(type){
				console.log("type="+type);
                    this.quoteType = type;
					this.getQuotes();
                }
            },
        },

        initialize: function(){
            this.quoteType = 'forex';
            this.accountType = 'standard';

            this.getQuotes();
            this.setTimer();

            // Cache the selector to avoid reading the dom every 1.5s.
            this.$trSelector = $('.quotes_row table tr');
        },

        // Recursively calling the set timeout makes sure that we don't have two of them running at the same time.
        setTimer: function(){
            var that = this;
            setTimeout(function(){
                $.when(
                    that.getQuotes()
                ).done(function(){
                    that.setTimer();
                });
            }, 1500);
        },

        getQuotes: function(){
            var that = this;

            var quote = new Quote();
//console.log(quote);
            // Return the fetch promise
            return quote.fetch({
                data: {
					'type' : this.quoteType,
					'promotion': this.accountType,
					't': $.now()
                },
                success: function( model, response, option) {
				//console.log(response);
                    that.$trSelector.each(function(index){
                        var quote = response.quotes[index];
                        $(this).find('.bid').html(quote.bid);
                        $(this).find('.ask').html(quote.ask);
                        $(this).find('.symbol').html(quote.symbol);
                        $(this).find('.spread').html(quote.spread);
                    });
                },
                fail: function( model, response, option) {
				//console.log(response);
                },
            });
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/main/test_view.js
// module id = 31
// module chunks = 0